import { render } from "./InvoiceDetail.vue?vue&type=template&id=1032f720&ts=true"
import script from "./InvoiceDetail.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__